import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/AboutSection.css';
import hotelImage from '../assets/images/bg1.webp'; // replace with your actual image path

const AboutSection = ({ language }) => {
  const sectionRef = useRef(null);
  const [visible, setVisible] = useState(false);

  // Detect when the section is in the viewport
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setVisible(true);
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className={`about-section container my-5 ${visible ? 'fade-in' : ''}`}
    >
      <div className="row align-items-center">
        <div className="col-md-5 mb-4 mb-md-0">
          <img
            src={hotelImage}
            alt="Blue Nest Hotel"
            className="img-fluid rounded shadow-sm custom-img"
          />
        </div>
        <div className="col-md-7">
<h6 className="text-uppercase text-muted mb-2 about-label">
  {language === 'en' ? 'About Us' : 'ስለ እኛ'}
</h6>
<h2 className="fw-bold mb-3">
  {language === 'en' 
    ? 'The Best Holidays Start Here!' 
    : 'ተስማሚ ቀኖች እዚህ ይጀምራሉ!'}
</h2>
<p className="text-secondary">
  {language === 'en'
    ? 'The Ethiopian Defense Forces Officers Club, based in Addis Ababa, Ethiopia, is an organization that provides a variety of services to military personnel and their families, governmental and non-governmental organizations, and the public at reasonable prices and in a quality manner, including hotel, bar, gym, tennis, wedding and graduation arrangements, hall rental, and other services.'
    : 'የኢትዮጵያ መከላከያ ሰራዊት መኮንኖች ክለብ መቀመጫውን በአዲስ አበባ ኢትዮጵያ ያደረገ  ለወታደራዊ ሰራተኞችና ቤተሰቦቻቸው፣ ለመንግስታዊ እና መንግሥታዊ ላልሆኑ  ድርጅቶችና ህዝቦች ፍላጎት ለማሟላት የተለያዩ ዝግጅቶችን በሚቀርቡለት ጥያቄ መሰረት በተመጣጣኝ ዋጋ እና በጥራት የሆቴል፣የባር፣የጅም፣የሜዳ ቴንስ፣የጋብቻ እና ምርቃት ዝግጅት፣የአዳራሽ ኪራይ እና ሌሎች  አገልግሎቶችን እየሰጠ የሚገኝ ድርጅት ነው።'}
</p>
<div className="text-center">
  <Link to="/about">
    <button className="btn btn-danger mt-3">
      {language === 'en' ? 'Read More' : 'ተጨማሪ ያንብቡ'}
    </button>
  </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
